export default import.meta.ROLLDOWN_FILE_URL_q42vZNsP$k3A73RSIvWJcw